import * as React from "react";
const SvgDocumentation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M8 13.333a6.398 6.398 0 0 0-1.734-.983A5.46 5.46 0 0 0 4.333 12c-.467 0-.925.06-1.375.183-.45.122-.88.294-1.292.517a.642.642 0 0 1-.674-.017.644.644 0 0 1-.325-.583V4.066c0-.122.03-.239.091-.35a.575.575 0 0 1 .275-.25 6.956 6.956 0 0 1 1.6-.6 7.26 7.26 0 0 1 1.7-.2 7.187 7.187 0 0 1 3.667 1V12.1a6.816 6.816 0 0 1 1.783-.825A6.63 6.63 0 0 1 11.666 11c.4 0 .837.039 1.309.116.472.078.925.24 1.358.484V3.183c.11.042.218.085.324.131.106.046.21.097.31.152.11.067.2.154.266.262.067.107.1.22.1.338V12.1c0 .255-.108.45-.325.583a.642.642 0 0 1-.675.017 6.033 6.033 0 0 0-1.292-.517A5.224 5.224 0 0 0 11.666 12a5.46 5.46 0 0 0-1.933.35c-.622.233-1.2.56-1.733.983Zm1-2.783V4.666L13.333.333v6.45L9 10.55ZM7 11.6V4.283a4.488 4.488 0 0 0-1.317-.467c-.5-.1-.95-.15-1.35-.15a6.129 6.129 0 0 0-2.667.592V11.6a6.015 6.015 0 0 1 1.259-.442c.45-.105.922-.158 1.417-.158A6.081 6.081 0 0 1 7 11.6Z"
    />
  </svg>
);
export default SvgDocumentation;
